<script setup lang="ts">
import { onLaunch, onShow, onHide, onPageNotFound } from '@dcloudio/uni-app'
import { wxLogin, refreshToken } from '@/service/login/index'
import { SSOParseReq } from '@/service/user/index'
import { syncUpAppNavTitleByPath, initUpAppNavigationLayout } from '@/utils/base'
import { initH5LocationNavLoading } from '@/utils/h5-location-nav-loading'
import { syncAppLocaleFromStorage } from '@/locale/apply-locale'
import { syncEntrySourceFromRoutePath } from '@/utils/shopJointLogin'
import { useUserStore } from '@/store/user'
import { watch, ref } from 'vue'
import { useRoute } from 'vue-router'

const userStore = useUserStore()
const route = useRoute()

// 监听路由变化


watch(
  () => route.fullPath,
  (newPath, oldPath) => {
    // 检查URL中是否包含SSOkey参数
    if (newPath.includes('SSOkey=')) {
      try {
        // 从URL中提取SSOkey参数值
        const SSOkeyMatch = newPath.match(/SSOkey=([^&]+)/)
        if (SSOkeyMatch && SSOkeyMatch[1]) {
          const SSOkey = decodeURIComponent(SSOkeyMatch[1])
          console.log('提取到的SSOkey:', SSOkey)

          // 调用SSOParseReq接口处理SSO登录
          _SSOParseReq(SSOkey)
        }
      } catch (error) {
        console.error('处理SSOkey时出错:', error)
      }
    }
    // 使用统一的URL参数解码方法
    const processedPath = processUrlDecoding(newPath)
    syncEntrySourceFromRoutePath(processedPath.split('#')[0] ?? processedPath)
    postCurrentPageInfo(processedPath)
    syncUpAppNavTitleByPath(processedPath)
  },
  { immediate: true },
)



// 处理URL参数解码的通用方法
function processUrlDecoding(path) {
  let processedPath = path
  
  // 如果路径包含酒店详情页，对name参数进行解码
  if (processedPath.includes('/hotel/hotel_detail/hotel_detail')) {
    const nameMatch = processedPath.match(/name=([^&]+)/)
    if (nameMatch && nameMatch[1]) {
      const decodedName = decodeURIComponent(decodeURIComponent(nameMatch[1]))
      processedPath = processedPath.replace(/name=[^&]+/, `name=${decodedName}`)
    }
  }
  // 如果路径包含机票列表，对startCity参数进行解码
  if (processedPath.includes('/plane/plane_list/plane_list') || processedPath.includes('/pageB/international_plane/international_plane_list') || processedPath.includes('/plane/plane_return/plane_return')) {
    const nameMatch = processedPath.match(/startCity=([^&]+)/)
    const endCity = processedPath.match(/endCity=([^&]+)/)
    if (nameMatch && nameMatch[1]) {
      const decodedName = decodeURIComponent(decodeURIComponent(nameMatch[1]))
      processedPath = processedPath.replace(/startCity=[^&]+/, `startCity=${decodedName}`)
    }
    if (endCity && endCity[1]) {
      const endCityName = decodeURIComponent(decodeURIComponent(endCity[1]))
      processedPath = processedPath.replace(/endCity=[^&]+/, `endCity=${endCityName}`)
    }
  }
  // 如果路径包含火车票列表，对站点名称进行解码
  if (processedPath.includes('/pageB/train/train_list')) {
    const fromStation = processedPath.match(/fromStationName=([^&]+)/)
    const toStation = processedPath.match(/toStationName=([^&]+)/)
    if (fromStation && fromStation[1]) {
      const decodedFrom = decodeURIComponent(decodeURIComponent(fromStation[1]))
      processedPath = processedPath.replace(/fromStationName=[^&]+/, `fromStationName=${decodedFrom}`)
    }
    if (toStation && toStation[1]) {
      const decodedTo = decodeURIComponent(decodeURIComponent(toStation[1]))
      processedPath = processedPath.replace(/toStationName=[^&]+/, `toStationName=${decodedTo}`)
    }
  }
  
  return processedPath
}

// 重写 history.replaceState，自动发送URL变动消息给小程序
const originalReplaceState = history.replaceState.bind(history)
history.replaceState = function (state, title, url) {
  originalReplaceState(state, title, url)
  // URL变动后发送消息给小程序，需要处理参数解码
  const currentPath = window.location.pathname + window.location.search
  console.log('当前路径', currentPath)
  const processedPath = processUrlDecoding(currentPath)
  syncEntrySourceFromRoutePath(processedPath.split('#')[0] ?? processedPath)
  postCurrentPageInfo(processedPath)
  syncUpAppNavTitleByPath(processedPath)
}


onLaunch(() => {
  console.log('App Launch')
  syncAppLocaleFromStorage()

















  initUpAppNavigationLayout()
  initH5LocationNavLoading()
  // 重复刷新token
  setInterval(() => {
    refreshUserInfo()
  }, 1000)

})

//token过期刷新
async function refreshUserInfo() {
  let nowDate = new Date().getTime()
  let refresh = userStore.expire
  // var time = new Date(refresh)
  // var y = time.getFullYear()
  // var m = time.getMonth() + 1
  // var d = time.getDate()
  // var h = time.getHours()
  // var mm = time.getMinutes()
  // var s = time.getSeconds()
  // console.log('这是保存时间', y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s)
  // console.log(`当前的时间:`, nowDate + 10000)
  // var time1 = new Date(nowDate + 10000)
  // var y1 = time1.getFullYear()
  // var m1 = time1.getMonth() + 1
  // var d1 = time1.getDate()
  // var h1 = time1.getHours()
  // var mm1 = time1.getMinutes()
  // var s1 = time1.getSeconds()
  // console.log('这是当前时间', y1 + '-' + m1 + '-' + d1 + ' ' + h1 + ':' + mm1 + ':' + s1)
  if (refresh && refresh <= nowDate + 10000) {
    let res = await refreshToken({
      token: userStore.userInfo.refreshToken,
    })
    if (res.code == 200) {
      let data=userStore.userInfo
      data.token=res.data.token
      data.expire=res.data.expire
      data.refreshToken=res.data.refreshToken
      userStore.setUserInfo(data)
      userStore.setToken(res.data.token)
      userStore.setExpire(res.data.expire)
    } else {
      if (res.error_code == 400 || res.code == 400 || res.error_code == 401 || res.code == 401) {
        console.log(`用户信息token刷新失败`)
        userStore.clear()
        return false
      }
    }
  }
}
onShow(() => {

  if (uni.getStorageSync('usertype') === 'elder') {
    // 适老化模式
    var html = document.querySelector('html')
    html.setAttribute('class', 'elder')
  } else {
    var html = document.querySelector('html')
    html.setAttribute('class', '')
  }

  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})

// 单点登录
async function _SSOParseReq(SSOkey) {
  let res = await SSOParseReq({
    SSOkey: decodeURI(SSOkey),
  })
  if (res.code == 200) {
    userStore.setUserInfo(res.data)
    userStore.setToken(res.data.token)
    userStore.setExpire(res.data.expire)
  } else {
    uni.showToast({
      title: res.msg,
      icon: 'none',
    })
  }
}
// 发送当前页面信息
function postCurrentPageInfo(newPath) {
  // console.log('发送当前页面路径', newPath)
  setTimeout(() => {
    try {
      webUni.postMessage({
        data: {
          action: 'updateCurrentPath',
          path: newPath,
        },
      })
    } catch (e) {
      console.log('发送当前页面路径失败', e)
    }
  }, 100)
}
</script>

<style lang="less">
/* 强制恢复滚动（iOS WebView 须 -webkit-overflow-scrolling 才稳定响应 touch 滚动） */
page-container {
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  position: static !important;
  min-height: 100vh !important;
  height: auto !important;
}

/* 下单弹层打开时，锁定实际承载页面滚动的容器。 */
page-container.hotel-order-popup-open,
page-container.combined-order-popup-open,
page-container.tourism-order-popup-open,
page-container.plan-cart-popup-open {
  overflow-y: hidden !important;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto !important;
}

page {
  position: relative !important;
  top: 0px !important;
}
.elder {
  .uni-tabbar__label {
    color: #019fe8 !important;
  }
  .uni-input-input {
    font-size: 40rpx;
  }
  .wd-checkbox__txt {
    font-size: 40rpx;
  }
  .uni-input-placeholder {
    font-size: 40rpx !important;
  }
  .wd-tabs__nav-item {
    font-size: 40rpx !important;
  }
  .wd-picker__value {
    font-size: 40rpx;
  }
  .uni-simple-toast__text {
    font-size: 20px;
  }

  .uni-tabbar {
    height: 90px;
    /* 设置你想要的高度，单位可以是px、rem等 */
  }

  //导航栏字体
  .uni-page-head .uni-page-head__title {
    font-size: 32rpx !important;
  }

  // tab图标
  .uni-tabbar .uni-tabbar__icon {
    width: 40px !important;
    height: 40px !important;
  }
}
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

// 云闪付 WebView：底部弹窗兜底，禁止横向溢出
.wd-popup {
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
</style>
